import React from 'react'

const Data = () => {
    return (
        <div>
            <h1 className="home_title">
                Sourav Barik
            </h1>
            <h3 className="home_subtitle">
                Upcoming Full Stack Web Developer
            </h3>
            <p className="home_description">
            "Discover the world of computer science through my portfolio, where each project highlights my technical 
            expertise and innovative problem-solving skills."
            </p>
            <a href="#contact" className='button mini button-flex'>Connect With Me</a>
        </div>
    )
}

export default Data